import { useQuery } from "@tanstack/react-query";

import { axios } from "@/admin/libs/axios";

export interface AdminRevenueSnapshot {
  kpis: Array<{
    label: string;
    value: number;
    wowDelta: number | null;
    format: "count" | "currency";
    currency?: string;
  }>;
  recentPayments: Array<{
    id: string;
    customerEmail: string | null;
    customerName: string | null;
    amount: number;
    currency: string;
    status: string;
    description: string | null;
    createdAt: string;
    stripeDashboardUrl: string;
  }>;
  mrrByCurrency: Array<{ currency: string; amount: number }>;
  updatedAt: string;
}

export const fetchAdminRevenue = async (): Promise<AdminRevenueSnapshot> => {
  const { data } = await axios.get<AdminRevenueSnapshot>("/admin/revenue");
  return data;
};

export const useAdminRevenue = () =>
  useQuery({
    queryKey: ["admin", "revenue"],
    queryFn: fetchAdminRevenue,
    // Stripe's rate limits make this worth caching aggressively client-side.
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
